import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {APP_BASE_HREF} from "@angular/common";
import { FilterEditorComponent } from './components/filter-editor/filter-editor.component';
import {HttpClientModule} from "@angular/common/http";
import { ImagePageComponent } from './pages/image-page/image-page.component';
import { ImportPageComponent } from './pages/import-page/import-page.component';
import {FormsModule} from "@angular/forms";
import {NgxMasonryModule} from "ngx-masonry";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';

@NgModule({
  declarations: [
    AppComponent,
    FilterEditorComponent,
    ImagePageComponent,
    ImportPageComponent,
    LoadingIndicatorComponent
  ],
  imports: [
    BrowserModule,BrowserAnimationsModule,
    AppRoutingModule, HttpClientModule, FormsModule,NgxMasonryModule
  ],
  providers: [{provide: APP_BASE_HREF, useValue: '/kuniweb'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
